/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    this.setupEventListeners();
  }
  onChange(event) {
    if (event.target.type == 'number') {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    }
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    });
  }
  setupEventListeners() {
    this.removeProductEvent();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });
    console.log("setupEventListeners for main cart");

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.termsCheckbox();
  }
  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-bubble'
    }];
  }
  displayErrors(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  async updateQuantity(line, quantity) {

    this.container.classList.add('cart-disabled');
    if (line) {
      this.container.querySelector(`#CartItem-${line}`).classList.add('loading');
    }

    // Keep Extended Warranty line items in sync with their product's quantity.
    // Warranty lines carry a hidden `_for_product` = the product variant id (see
    // assets/product.js). If the line being changed is a product that has warranty
    // lines bound to it, update the product AND its warranties to the same quantity
    // (0 removes them together) in a single cart/update.js call — keyed by line-item
    // key so re-indexing from cart/change.js can't misalign them.
    let warrantyUpdates = null;
    try {
      let liveCart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
      let target = liveCart.items[parseInt(line) - 1];
      if (target && !(target.properties && target.properties['_for_product'])) {
        let boundWarranties = liveCart.items.filter((li) =>
          li.properties && String(li.properties['_for_product']) === String(target.variant_id));
        if (boundWarranties.length) {
          warrantyUpdates = {};
          warrantyUpdates[target.key] = parseInt(quantity);
          boundWarranties.forEach((li) => { warrantyUpdates[li.key] = parseInt(quantity); });
        }
      }
    } catch (e) { console.error('Warranty quantity-sync lookup failed:', e); }

    let changeUrl = `${theme.routes.cart_change_url}`;
    let body;
    if (warrantyUpdates) {
      changeUrl = window.Shopify.routes.root + 'cart/update.js';
      body = JSON.stringify({
        updates: warrantyUpdates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
    } else {
      body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
    }
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(changeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then(async (response) => {
        let {variant_id_in_cart: variants_to_delete, variant_to_add} = await calculateProtectionQty();
        if(variant_to_add <= 0 && variants_to_delete.length == 0){
          return response.text();
        }else{
          console.log("variants_to_delete:", variants_to_delete);
          console.log("variant_to_add:", variant_to_add);
          let updates = {};
          if(variant_to_add > 0){
            updates[variant_to_add] = 1;
          }
          for(let item_to_d of variants_to_delete){
            if(parseInt(item_to_d) != parseInt(variant_to_add)){
              updates[item_to_d] = 0;
            }
          }
          console.log("updates:", updates);
          return fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ 
                updates,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              })
          }).then((res) => {return res.text()});
        }
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElements = document.querySelectorAll(`#CartItem-${line} input[name="updates[]"]`);

        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          quantityElements.forEach(function (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          });
          this.container.classList.remove('cart-disabled');
          return;
        }
        this.renderContents(parsedState, line, false);

        this.container.classList.remove('cart-disabled');

        //for extra product add and remove
				let eventName = "cartMain:refreshDone";
				let event = new CustomEvent(eventName,  null);
				document.dispatchEvent(event);

        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
      });
  }
  refresh() {
    this.container.classList.add('cart-disabled');

    let sections = 'main-cart';

    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, false, true);

        this.container.classList.remove('cart-disabled');

        //for extra product add and remove
				let eventName = "cartMain:refreshDone";
				let event = new CustomEvent(eventName,  null);
				document.dispatchEvent(event);
      });
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartTerms'),
      checkout_button = this.container.querySelector('.button.checkout-button');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', async (event) => {
        /*
        this.updateQuantity(event.target.dataset.index, '0');
        event.preventDefault();
        */
        event.preventDefault();
        this.container.querySelector(`#CartItem-${remove.dataset.index}`)?.classList.add('loading');
        console.log("remove icon clicked");
        let same_bundles_products = [];
        let product_id = event.target.dataset.product;
        let variant_id = event.target.dataset.variant;
        if (typeof window.bndlr !== 'undefined' && typeof window.bndlr.getBundles === 'function') {
          let bundles = window.bndlr.getBundles();
          bundles.forEach(function (bundle){
            let products = bundle.products;
            if(products[product_id] && products[product_id]['variants'][variant_id]){
              for(let prd_id in products){
                same_bundles_products.push({
                  product: prd_id,
                  variant: Object.keys(products[prd_id]['variants'])
                })
              }
            }
          });
        }
        let updates = {};
        updates[variant_id] = 0;
        same_bundles_products.forEach(function (bundle_info){
          if(bundle_info.product != product_id && !bundle_info.variant.includes(variant_id)){
            bundle_info.variant.forEach((va) => {
              console.log("Add key:", va);
              updates[va] = 0;
            });
          }
        });
        let isShippingProtection = window.shippingProtectionVariantIds && window.shippingProtectionVariantIds.includes(parseInt(variant_id));
        // If a main product is being removed, also remove any Extended Warranty
        // line items bound to it (added with a hidden `_for_product` = this variant
        // id, see assets/product.js). Warranty lines are matched by line-item key so
        // we only drop the ones tied to this product, never same-variant warranties
        // on other products.
        try {
          let liveCart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
          let removed_is_warranty = liveCart.items.some((li) =>
            parseInt(li.variant_id) === parseInt(variant_id) && li.properties && li.properties['_for_product']);
          if (!removed_is_warranty) {
            liveCart.items.forEach((li) => {
              if (li.properties && String(li.properties['_for_product']) === String(variant_id)) {
                updates[li.key] = 0;
              }
            });
          }
        } catch (e) { console.error('Warranty cascade lookup failed:', e); }
        let fetchBody = { updates };
        if (isShippingProtection) {
          fetchBody.attributes = { 'shipping_protection_dismissed': 'true' };
        }
        console.log("remove_req:", updates);
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(fetchBody)
        })
        .then(async response => {
            
          let {variant_id_in_cart: variants_to_delete, variant_to_add} = await calculateProtectionQty();
          if(variant_to_add <= 0 && variants_to_delete.length == 0){
            window.location.reload();
            return response.json();
          }else{
            console.log("variants_to_delete:", variants_to_delete);
            console.log("variant_to_add:", variant_to_add);
            let updates = {};
            if(variant_to_add > 0){
              updates[variant_to_add] = 1;
            }
            for(let item_to_d of variants_to_delete){
              if(parseInt(item_to_d) != parseInt(variant_to_add)){
                updates[item_to_d] = 0;
              }
            }
            console.log("updates:", updates);
            return fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ 
                  updates
                })
            }).then((res) => {window.location.reload(); return res.text()});
          }

        })
        .catch((error) => {
          console.error('Error:', error);
          this.container.querySelector(`#CartItem-${remove.dataset.index}`)?.classList.remove('loading');
        });
        console.log(same_bundles_products);
        console.log("---------------------")
      });
    });
  }
  renderContents(parsedState, line, refresh) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      if (refresh) {
        if (parsedState[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }
      } else {
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }

      this.removeProductEvent();

      if (line && this.container.querySelector(`#CartItem-${line}`)) {
        this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
      this.termsCheckbox();
    }));
  }
}
document.addEventListener('DOMContentLoaded', () => {
  if (typeof Cart !== 'undefined') {
    new Cart();
  }
});